import React from 'react';
import { connect } from 'react-redux';

import DropDown from './DropDown';

import { changePageParams } from 'actions';

import GlobalParamsStore from 'stores/GlobalParamsStore';

const GlobalParamsButtons = ({ params, paramsPending, changeGlobalParam }) => {
    const items = GlobalParamsStore.getMenuConfig();
    items.forEach(item => {
        item.onChange = changeGlobalParam;
    });
    return (
        <div className="cc-global-params-buttons">
            <ul>
                {items.map((item, index) => {
                    let value = paramsPending && paramsPending[item.id];
                    let loading;
                    if (value !== undefined) {
                        loading = true;
                    } else {
                        value = params[item.id];
                    }
                    return (
                        <li key={index}>
                            <DropDown data={item} value={value} loading={loading} />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

const mapStateToProps = state => ({
    params: state.params,
    paramsPending: state.paramsPending
});

const mapDispatchToProps = dispatch => ({
    changeGlobalParam: (field, value) => {
        dispatch(changePageParams(field, value));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalParamsButtons);



// WEBPACK FOOTER //
// ./src/components/GlobalParamsButtons.jsx